import { render } from "./NotFound.vue?vue&type=template&id=a5f01a0a"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=a5f01a0a&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.30_vue@3.5.27_typescript@5.9.3__webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__